import axios from 'axios';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URI}/api/`, // our API base URL
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Interceptor to handle errors globally
api.interceptors.response.use(
    (response) => { // If the response is successful, return the response
        if (response.data.statusCode === 401 && response.data.isSuccess === false) {
            localStorage.removeItem('token');
            window.location.href = '/user/authentication/sign-in';
        } else {
            return response;
        }
    },
    (error) => {
        if (error.response) {
            const { status } = error.response;

            if (status === 401) {
                localStorage.removeItem('token');
                window.location.href = '/user/authentication/sign-in';
            }

            if (status === 403) {
                const message = error.response.data?.message || 'Zugriff verweigert.';
                return Promise.resolve({ data: { isSuccess: false, status: 403, message } });
            }

            if (status === 409) {
                const message = error.response.data?.message || 'Eintrag existiert bereits.';
                return Promise.resolve({ data: { isSuccess: false, status: 409, message } });
            }
        }

        return Promise.reject(error);
    },
);

export default api;
